import React, { useState } from "react";
import { initiateHandshake } from '../../utils/HandshakeManager';
import { usePasswordAndUserId } from "../../context/AuthContext";
import bs58 from "bs58";
import { getMessageTargets } from "../../services/message/GetMessageTargets";

export default function ReestablishSecureConnectionMessage({
  conversationId,
  participants,
  localKeys,
  fullScreen = false,
}) {
  const [status, setStatus] = useState("init");
  const [dismissed, setDismissed] = useState(false);
  const { password, userId, salt } = usePasswordAndUserId();

  if (participants?.length === 0 || dismissed) return null;

  const reEstablishConnection = async () => {
    try {
      setStatus("sending");

      const targets = getMessageTargets(participants || []);  

      await Promise.all(
        targets.map((p) =>
          initiateHandshake({
            conversationId,
            contactIdentityViewPublicKey: p.identityViewPublicKey,
            contactNextViewPublicKey: p.contactNextViewPublicKey,
            kyberSecret: p.kyberSecret,
            password,
            userId,
            salt,
            forceNewHandshake: true,
          })
        )
      );

      setStatus("sent");
    } catch (err) {
      console.error("Failed to re-establish connection:", err);
      setStatus("error");
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
  };

  return (
    <div
      style={{
        background: "#222",
        padding: fullScreen ? "2rem 1.5rem" : "1rem",
        borderRadius: "8px",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        maxWidth: fullScreen ? "600px" : "80%",
        alignSelf: "center",
        margin: fullScreen ? "auto" : "1rem 0",
        boxSizing: "border-box",
        justifyContent: fullScreen ? "center" : "initial",
        minHeight: fullScreen ? "60vh" : "initial",
        alignItems: fullScreen ? "center" : "flex-start",
        textAlign: fullScreen ? "center" : "left",
        position: "relative",
      }}
    >
    <button
      onClick={handleDismiss}
      style={{
        position: "absolute",
        top: "0.5rem",
        right: "0.5rem",
        background: "none",
        border: "none",
        color: "#aaa",
        fontSize: "1rem",
        cursor: "pointer",
      }}
    >
      ✕
    </button>

      {fullScreen && (
        <img
          src="/images/logo.png"
          alt="Logo"
          style={{
            width: "200px",
            margin: "0 auto 1.5rem",
            opacity: 0.9,
          }}
        />
      )}

      <p
        style={{
          marginBottom: "1rem",
          textAlign: "left",
          fontSize: "1.1rem",
          lineHeight: "1.5",
        }}
      >
        <strong>Boost your privacy by refreshing the secure connection.</strong><br/>
        Rotates encryption keys for maximum message protection.
      </p>

      <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
        <button
          onClick={reEstablishConnection}
          disabled={status === "sending" || status === "sent"}
          style={{
            background: status === "sent" ? "#2ecc71" : "#4e8cff",
            color: "#fff",
            border: "none",
            padding: "0.75rem 1.25rem",
            borderRadius: "6px",
            fontSize: "1rem",
            cursor:
              status === "sending" || status === "sent" ? "default" : "pointer",
            opacity: status === "sending" ? 0.6 : 1,
          }}
        >
          {status === "sending"
            ? "Sending…"
            : status === "sent"
            ? "Connection Re-established"
            : "Reconnect Securely"}
        </button>
      </div>
    </div>
  );
}